import SectionHeading from "./SectionHeading";
import { exposeItems } from "@/mocks/feed";

export default function HotToday() {
  const featured = exposeItems[0];
  const list = exposeItems.slice(1, 6);

  return (
    <section id="hot" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8">
        <SectionHeading
          eyebrow="TODAY · 今日热瓜"
          title="今天讨论度最高的几条爆料"
          desc="按当前热度排序，先看大瓜再看细节。每条都标注了来源口径，请结合后续回应理性判断。"
        />
        <a
          href="#ranking"
          className="self-start md:self-auto inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
        >
          查看完整热度榜
          <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
        <article className="lg:col-span-3 group flex flex-col bg-background-100 border border-background-200 rounded-lg overflow-hidden">
          <div className="relative w-full h-56 md:h-80 overflow-hidden">
            <img
              src={featured.image}
              alt={featured.title}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute top-4 left-4 inline-flex items-center gap-1 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-md">
              <i className="ri-fire-fill" />
              今日头条大瓜
            </span>
            <span className="absolute top-4 right-4 bg-foreground-950/70 backdrop-blur text-background-50 text-xs px-2.5 py-1 rounded-md">
              热度 {featured.heat}
            </span>
          </div>
          <div className="p-5 md:p-6">
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-label text-sm text-primary-700 bg-primary-100 px-2.5 py-1 rounded-md">
                {featured.category}
              </span>
              {featured.tags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs text-secondary-900 bg-secondary-100 px-2.5 py-1 rounded-md"
                >
                  {tag}
                </span>
              ))}
            </div>
            <h3 className="mt-3 text-lg md:text-2xl font-bold text-foreground-950 leading-snug">
              {featured.title}
            </h3>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              {featured.summary}
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs md:text-sm text-foreground-500">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-user-voice-line" />
                {featured.source}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-time-line" />
                {featured.time}
              </span>
            </div>
          </div>
        </article>

        <div className="lg:col-span-2 flex flex-col gap-4">
          {list.map((item, index) => (
            <article
              key={item.id}
              className="group flex gap-4 bg-background-100 border border-background-200 rounded-lg p-3 md:p-4 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-24 h-24 sm:w-28 sm:h-20 shrink-0 rounded-md overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-1.5 left-1.5 w-5 h-5 flex items-center justify-center bg-primary-500 text-background-50 text-xs font-bold rounded-sm">
                  {index + 2}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="text-xs text-accent-700 bg-accent-100 px-2 py-0.5 rounded-md">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-500">热度 {item.heat}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.source}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}